import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';

import { HttpResponse } from '@angular/common/http';


@Injectable()
export class BulkReviewService {

  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService) {
  }

  handleError = (error) => {
    return throwError(error);
  }

  uploadReview(reviewUrl, Obj, companyId) {
    reviewUrl = this.httpClientService.replaceTextInUrl('{companyId}', companyId, reviewUrl);
    return this.httpClientService.authorizedPut(reviewUrl, Obj)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }
}
